export default function formatMessageContentEventSocket ({
    text,
    status
}) {
    return {
        text,
        status
    }
}
